/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Intro_WhyInputs */



/**
* | output |
* | --- |
* | "Why teams pick oneAI: your data stays yours and stays in Europe, admins govern who may use which models and tools, every action is auditable, and you switch ..." |
*
* @param {Onboarding_Intro_WhyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_intro_why = /** @type {((inputs?: Onboarding_Intro_WhyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Intro_WhyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Warum Teams oneAI wählen: Deine Daten bleiben deine und bleiben in Europa, Admins steuern, wer welche Modelle und Tools nutzen darf, jede Aktion ist nachvollziehbar, und du wechselst das Modell, ohne die App zu wechseln. Compliance ist eingebaut, nicht angeschraubt.")
	return /** @type {LocalizedString} */ ("Why teams pick oneAI: your data stays yours and stays in Europe, admins govern who may use which models and tools, every action is auditable, and you switch models without switching apps. Compliance is built in, not bolted on.")
});